import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_MERCHANT_LINK_PAYMENT,
  GET_MERCHANT_LINK_PAYMENT_BY_GUID,
  ADD_MERCHANT_LINK_PAYMENT,
  UPDATE_MERCHANT_LINK_PAYMENT,
  DELETE_MERCHANT_LINK_PAYMENT,
  UPDATE_MERCHANT_LINK_PAYMENT_STATUS,
  SHARE_MERCHANT_LINK_PAYMENT,
  GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY,
  MERCHANT_LINK_DO_PAYMENT,
  MERCHANT_LINK_CHECK_BIN_CARD_NUMBER
} from "./actionTypes"

import {

  getMerchantLinkPaymentSuccess,
  getMerchantLinkPaymentByGuidSuccess,
  addMerchantLinkPaymentSuccess,
  updateMerchantLinkPaymentSuccess,
  deleteMerchantLinkPaymentSuccess,
  updateMerchantLinkPaymentStatusSuccess,
  shareMerchantLinkPaymentSuccess,
  getMerchantLinkPaymentSpesificByKeySuccess,
  merchantLinkDoPaymentSuccess,
  merchantLinkPaymentError,
  merchantLinkCheckBinCardNumberSuccess,
  merchantLinkCheckBinCardNumberFail

} from "./actions"

//Include Both Helper File with needed methods
import {

  getAllMerchantLinkPaymentByUserName,
  getMerchantLinkPaymentByGuid,
  addMerchantLinkPayment,
  updateMerchantLinkPayment,
  deleteMerchantLinkPayment,
  updateMerchantLinkPaymentByStatus,
  merchantLinkPaymentShare,
  getMerchantLinkPaymentSpesificByKey,
  merchantLinkDoPayment,
  merchantLinkCheckBinCardNumber
} from "../../helpers/backend_helper/backend_helper"

import { toast, Zoom } from "react-toastify";
import i18n from 'i18n';
import { isCheckBinErrorResponse, toPlainApiError } from "helpers/apiErrorHelper";

function* onGetMerchantLinkPayment({ payload: userName }) {
  try {
    const response = yield call(getAllMerchantLinkPaymentByUserName, userName)
    yield put(getMerchantLinkPaymentSuccess(response))
  } catch (error) {
    yield put(merchantLinkPaymentError(error))
  }
}

function* onGetMerchantLinkPaymentByGuid({ payload: guid }) {
  try {
    const response = yield call(getMerchantLinkPaymentByGuid, guid)
    yield put(getMerchantLinkPaymentByGuidSuccess(response))
  } catch (error) {
    yield put(merchantLinkPaymentError(error))
  }
}

function* onGetMerchantLinkPaymentSpesificByKey({ payload: key }) {
  try {
    const response = yield call(getMerchantLinkPaymentSpesificByKey, String.fromCharCode(key.charCodeAt(4) + 3), String.fromCharCode(key.charCodeAt(5) + 3), String.fromCharCode(key.charCodeAt(2) + 3), String.fromCharCode(key.charCodeAt(0) + 3), String.fromCharCode(key.charCodeAt(1) + 3), String.fromCharCode(key.charCodeAt(3) + 3), String.fromCharCode(key.charCodeAt(1) + 1), String.fromCharCode(key.charCodeAt(1) + 1), key)
    localStorage.setItem("Act", response.d);

    if (response == null) { response.error = true }
    else if (response.a == false) { response.error = true }
    else if (response.p !== "2" && response.p !== "5") { response.error = true }
    else { response.error = false; }

    if (response.f) {
      response.nameSurnameVisibled = false;
      response.mailVisibled = false;
      response.phoneVisibled = false;
      response.addressVisibled = true;
    }
    if (response.e) {
      response.nameSurnameVisibled = false;
      response.mailVisibled = false;
      response.phoneVisibled = false;
      response.addressVisibled = false;
    }
    yield put(getMerchantLinkPaymentSpesificByKeySuccess(response))
  } catch (error) {
    const response = { error: false, errorMessage: "" };
    response.error = true;
    response.errorMessage = error.message;
    response.errorStatus = error.response?.status;
    yield put(getMerchantLinkPaymentSpesificByKeySuccess(response))
  }
}

function* onAddMerchantLinkPayment({ payload: record }) {
  try {
    const response = yield call(addMerchantLinkPayment, record)
    yield put(addMerchantLinkPaymentSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(merchantLinkPaymentError(error))
  }
}

function* onUpdateMerchantLinkPayment({ payload: record }) {
  try {
    const response = yield call(updateMerchantLinkPayment, record)
    yield put(updateMerchantLinkPaymentSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(merchantLinkPaymentError(error))
  }
}

function* onUpdateMerchantLinkPaymentStatus({ payload: guid }) {
  try {
    const response = yield call(updateMerchantLinkPaymentByStatus, guid)
    yield put(updateMerchantLinkPaymentStatusSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(merchantLinkPaymentError(error))
  }
}


function* onDeleteMerchantLinkPayment({ payload: guid }) {
  try {
    const response = yield call(deleteMerchantLinkPayment, guid)
    yield put(deleteMerchantLinkPaymentSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(merchantLinkPaymentError(error))
  }
}

function* onShareMerchantLinkPayment({ payload: record }) {
  try {
    const response = yield call(merchantLinkPaymentShare, record)
    yield put(shareMerchantLinkPaymentSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(merchantLinkPaymentError(error))
  }
}

function* onMerchantLinkDoPayment({ payload: record }) {
  try {
    const response = yield call(merchantLinkDoPayment, record)
    if (response == null) { response.error = true }
    else if (response.htmlFormSuccess != null && response.htmlFormSuccess !== "") {
      response.secureTransaction = true
    }
    else if (response.code != null && response.code !== "") {
      response.nonSecureTransaction = true
    }
    yield put(merchantLinkDoPaymentSuccess(response))
  } 
  catch (error) {
    const response = { error: true };
  
    response.errorMessage = error.message;
    response.errorStatus = error.response?.status;
    response.errorData = error.response?.data;
  
    yield put(merchantLinkDoPaymentSuccess(response));
  }
}

function* onMerchantLinkCheckBinCardNumber({ payload: record }) {
  try {
    const response = yield call(merchantLinkCheckBinCardNumber, record)
    if (isCheckBinErrorResponse(response)) {
      yield put(merchantLinkCheckBinCardNumberFail(toPlainApiError(response)))
      return
    }
    yield put(merchantLinkCheckBinCardNumberSuccess(response))
  } catch (error) {
    try {
      yield put(merchantLinkCheckBinCardNumberFail(toPlainApiError(error)))
    } catch (normalizeError) {
      yield put(merchantLinkCheckBinCardNumberFail({
        Code: "Error",
        Message: error?.message || "BIN check failed",
        Details: error?.message || "BIN check failed",
        CorrelationId: "",
        validationResults: [],
      }))
    }
  }
}

function* merchantLinkPaymentManagementSaga() {

  yield takeEvery(GET_MERCHANT_LINK_PAYMENT, onGetMerchantLinkPayment)
  yield takeEvery(GET_MERCHANT_LINK_PAYMENT_BY_GUID, onGetMerchantLinkPaymentByGuid)
  yield takeEvery(ADD_MERCHANT_LINK_PAYMENT, onAddMerchantLinkPayment)
  yield takeEvery(UPDATE_MERCHANT_LINK_PAYMENT, onUpdateMerchantLinkPayment)
  yield takeEvery(DELETE_MERCHANT_LINK_PAYMENT, onDeleteMerchantLinkPayment)
  yield takeEvery(UPDATE_MERCHANT_LINK_PAYMENT_STATUS, onUpdateMerchantLinkPaymentStatus)
  yield takeEvery(SHARE_MERCHANT_LINK_PAYMENT, onShareMerchantLinkPayment)
  yield takeEvery(GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY, onGetMerchantLinkPaymentSpesificByKey)
  yield takeEvery(MERCHANT_LINK_DO_PAYMENT, onMerchantLinkDoPayment)
  yield takeEvery(MERCHANT_LINK_CHECK_BIN_CARD_NUMBER, onMerchantLinkCheckBinCardNumber)
}

export default merchantLinkPaymentManagementSaga
